import React, { useState } from "react";
import { Button, Image, Skeleton, Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { formatPrice } from "../../../../library/utils";
import LocationLogo from "../../../../icons/svg/location.svg";
import { openUrlInTab } from "../../../../library/helpers";

const VehicleDetailCard = ({ images, year, make, model, trim, msrp, vdpLink, location }) => {
  const vehicleTitle = [year, make, model, trim].filter(Boolean).join(" ");
  const [previewVisible, setPreviewVisible] = useState(false);

  return (
    <div className="bg-[#F5F5F5] flex gap-3 p-3 border border-solid border-[#D9D9D9] rounded-lg">
      <div className="flex flex-col">
        <Image
          preview={false}
          placeholder={
            <Skeleton.Node style={{ width: 100, height: 70, borderRadius: 15 }} active />
          }
          fallback="https://funnel-webapp-uploads.s3.amazonaws.com/prod/images/generic-car-not-available-image.png"
          className="h-[70px] object-cover w-[100px] rounded-[15px]"
          src={images?.[0] || ""}
          alt="Vehicle"
        />
        <Button
          type="link"
          className="!p-0 !pt-1 text-[#1677FF]"
          onClick={() => setPreviewVisible(true)}
        >
          View Photos
        </Button>
      </div>

      <div style={{ display: "none" }}>
        <Image.PreviewGroup
          preview={{
            visible: previewVisible,
            onVisibleChange: vis => setPreviewVisible(vis),
          }}
          items={images || []}
        >
          <Image src={images?.[0] || ""} />
        </Image.PreviewGroup>
      </div>
      <div className="flex flex-col gap-1 w-full">
        <div className="w-full truncate text-black/[0.88] text-base font-semibold">
          {vehicleTitle || "N/A"}
        </div>
        <span className="text-sm font-normal text-black/[0.88]">
          <span>MSRP</span> {msrp ? `$ ${formatPrice(msrp)}` : "Price not available"}
          {vdpLink && (
            <Tooltip title="Open inventory">
              <LinkOutlined
                onClick={e => {
                  e.stopPropagation();
                  openUrlInTab(vdpLink);
                }}
                className="text-blue-500 ml-2 mt-1"
              />
            </Tooltip>
          )}
        </span>
        <div className="flex gap-2 items-center">
          <Image src={LocationLogo} />
          <span className="text-xs font-normal text-black/[0.65]">{location}</span>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetailCard;
